import React from 'react';
import { Box, BrowserNavigationRightIcon, OverflowText } from '@common-fe/common-fe';

import { RenewalProcessingTier } from '@/modules/Renewals/renewals.types';

import TierLevelBadge from './TierLevelBadge';

interface Props {
  tier: RenewalProcessingTier;
  tierIndex: number;
  textStyle?: React.CSSProperties;
}

const TierTitle: React.FC<Props> = ({ tier, tierIndex, textStyle }) => (
  <Box direction="row" align="center">
    <TierLevelBadge level={tierIndex + 1} />
    <Box margin={{ left: 'spacing4' }} width={{ min: '0px' }} flex={{ shrink: 1 }}>
      <OverflowText title={tier.name} textStyle={textStyle} />
    </Box>
    {tier.nextTierName && (
      <>
        <Box margin={{ horizontal: 'spacing8' }} flex={false}>
          <BrowserNavigationRightIcon size="16px" color="iconPrimary" />
        </Box>
        <TierLevelBadge level={tierIndex + 2} />
        <Box margin={{ left: 'spacing4' }} width={{ min: '0px' }} flex={{ shrink: 1 }}>
          <OverflowText title={tier.nextTierName} textStyle={textStyle} />
        </Box>
      </>
    )}
  </Box>
);

export default TierTitle;
